import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AddTrainingBatchComponent } from '../add-training-batch/add-training-batch.component';
import { pushToArray, orderBy } from 'src/app/services/mapping.service';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-training-batches',
  templateUrl: './training-batches.component.html',
  styleUrls: ['./training-batches.component.scss']
})
export class TrainingBatchesComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any = TABS.BATCHES;
  DISPLAY_STATUS_KEY: any;
  PROGRAM_KEY:any;

  constructor(
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private route:ActivatedRoute,
  ) { }

  async ngOnInit() {
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT.submitted;
    const { selectedCompanyKey } = this.auth;
    const programs: any[] = orderBy(pushToArray(await this.ds.programRef().get().toPromise()), "updated_at", "desc");
    this.tabs = programs.map(m => ({ path: `/training/batches/${m.key}`, label: m.name }));
    this.route.params.subscribe(params=>{
      const {id}=params;
      this.PROGRAM_KEY=id;
      this.store.fetchData(COLLECTION_NAME.BATCHES, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey,null,this.PROGRAM_KEY)
    })
    
  }

  create(item?: any) {
    const dialogRef = this.dialog.open(AddTrainingBatchComponent, {
      data: { ITEM: item || null,PROGRAM_KEY:this.PROGRAM_KEY, },
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.delete(COLLECTION_NAME.BATCHES, item, (success) => {
          if (success) {
            this.snackBar.open("Batch has been deleted successful.", "Done", { duration: 2500 });
          }
        })
      }
    });
  }

}
